import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { Container, Section } from '../../styles/GlobalStyles';

const ClientsContainer = styled(Section)`
  background: ${theme.colors.neutral.white};
  padding: ${theme.spacing['3xl']} 0;

  @media (max-width: ${theme.breakpoints.md}) {
    padding: ${theme.spacing.xl} 0;
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    padding: ${theme.spacing.lg} 0;
  }
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing['2xl']};

  @media (max-width: ${theme.breakpoints.md}) {
    margin-bottom: ${theme.spacing.xl};
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    margin-bottom: ${theme.spacing.lg};
  }
`;

const SectionTitle = styled.h2`
  font-size: ${theme.typography.fontSize['4xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  margin-bottom: ${theme.spacing.sm};
  
  .highlight {
    color: ${theme.colors.primary.synapse};
    position: relative;
  }
  
  .highlight::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    right: 0;
    height: 3px;
    background: ${theme.colors.primary.accent};
    border-radius: 2px;
  }

  @media (max-width: ${theme.breakpoints.md}) {
    font-size: ${theme.typography.fontSize['3xl']};
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    font-size: ${theme.typography.fontSize['2xl']};
    margin-bottom: ${theme.spacing.xs};
  }
`;

const SectionSubtitle = styled.p`
  font-size: ${theme.typography.fontSize.xl};
  color: ${theme.colors.neutral.gray600};
  line-height: ${theme.typography.lineHeight.relaxed};
  margin: 0;
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: ${theme.breakpoints.md}) {
    font-size: ${theme.typography.fontSize.lg};
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    font-size: ${theme.typography.fontSize.base};
  }
`;

const ClientShowcase = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 300px;
  margin: 0 auto;
`;

const ClientCard = styled.div`
  background: ${theme.colors.neutral.light};
  border: 1px solid ${theme.colors.neutral.gray200};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing['2xl']} ${theme.spacing['3xl']};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: all ${theme.transitions.normal};

  &:hover {
    border-color: ${theme.colors.primary.synapse};
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    padding: ${theme.spacing.xl} ${theme.spacing['2xl']};
  }
`;

const ClientLogo = styled.div`
  font-size: ${theme.typography.fontSize['4xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.primary.data};
  font-family: ${theme.typography.fontFamily.heading};

  @media (max-width: ${theme.breakpoints.sm}) {
    font-size: ${theme.typography.fontSize['3xl']};
  }
`;

const Clients: React.FC = () => {
  return (
    <ClientsContainer id="clients">
      <Container>
        <SectionHeader>
          <SectionTitle>
            <span className="highlight">Clientes</span> datasynapse
          </SectionTitle>
          
          <SectionSubtitle>
            Parceiros que confiam em nossas soluções de IA e dados
          </SectionSubtitle>
        </SectionHeader>

        <ClientShowcase>
          <ClientCard>
            <ClientLogo>who.</ClientLogo>
          </ClientCard>
        </ClientShowcase>
      </Container>
    </ClientsContainer>
  );
};

export default Clients; 